import { render, staticRenderFns } from "./LabelInput.vue?vue&type=template&id=1d9fd552&scoped=true&"
import script from "./LabelInput.vue?vue&type=script&lang=ts&"
export * from "./LabelInput.vue?vue&type=script&lang=ts&"
import style0 from "./LabelInput.vue?vue&type=style&index=0&id=1d9fd552&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9fd552",
  null
  
)

export default component.exports